import { transparentColors } from '@assets/styles/helpers/colors.styles'
import chatBotImage from '@assets/images/chatBotImage.png'

export const chatBotPopoverStyles = {
  '.MuiPaper-root': {
    '--Paper-shadow': 'none !important',
    boxSizing: 'border-box',
    background: transparentColors.blackShade6,
    backdropFilter: 'blur(3px)',
    width: '25rem',
    height: '37rem',
    bottom: '2rem',
    marginTop: '-0.5rem',
    borderRadius: '0.25rem',
    position: 'relative',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  }
}

export const chatBotButtonStyles = {
  position: 'relative', // fixes the stacking of :before
  width: '100%',
  height: '100%',
  minWidth: 0,
  borderRadius: '50%',
  backgroundColor: 'transparent', // fix typo + keep clear
  backgroundImage: `url(${chatBotImage}), linear-gradient(180deg, #dc5601 0%, #ee5f01 100%)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundClip: 'padding-box',
  outline: 'none !important',
  border: '0.5rem solid transparent',
  '&:hover': {
    borderColor: transparentColors.transparent
  },

  '&:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: '-1 !important',
    margin: '-0.5rem',
    borderRadius: 'inherit',
    background:
      'linear-gradient(129deg, rgba(0, 0, 0, 1) 0%, rgba(255, 101, 0, 1) 100%)'
  },

  '&:hover:before': {
    rotate: '360deg',
    transition: 'rotate 0.5s ease-in-out',
    borderColor: transparentColors.transparent
  }
}
